import axios from "axios";
import { store } from "./store/store";
import { refreshTokenSuccess, logout } from "./store/authSlice";

const AI_API_URL =
  process.env.REACT_APP_AI_API_URL ||
  process.env.REACT_APP_API_URL ||
  "https://34-23-1-18.sslip.io";
const API_URL =
  process.env.REACT_APP_API_URL ||
  "https://mindsherpa-uat-be-1035606630490.us-east1.run.app";

const aiApi = axios.create({
  baseURL: AI_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

aiApi.interceptors.request.use(
  (config) => {
    const state = store.getState();
    const token = state?.auth?.accessToken;
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

let isRefreshing = false;
let queue = [];

const resolveQueue = (error, token = null) => {
  queue.forEach((p) => (token ? p.resolve(token) : p.reject(error)));
  queue = [];
};

aiApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;

    if (error.response?.data?.error === "invalid_token") {
      store.dispatch(logout());
      return Promise.reject(error);
    }

    if (error.response?.status === 401 && !original._retry) {
      original._retry = true;

      const state = store.getState();
      const refreshToken = state?.auth?.refreshToken;

      if (!refreshToken) {
        store.dispatch(logout());
        return Promise.reject(error);
      }

      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          queue.push({
            resolve: (newAccess) => {
              original.headers.Authorization = `Bearer ${newAccess}`;
              resolve(aiApi(original));
            },
            reject: (err) => reject(err),
          });
        });
      }

      try {
        isRefreshing = true;
        const { data } = await axios.post(
          `${API_URL}/token/refresh`,
          { refresh_token: refreshToken },
          { headers: { Authorization: `Bearer ${refreshToken}` } }
        );

        const newAccess = data?.access_token;
        if (!newAccess) throw new Error("No access_token in refresh response");

        store.dispatch(refreshTokenSuccess({ access_token: newAccess }));
        resolveQueue(null, newAccess);

        original.headers.Authorization = `Bearer ${newAccess}`;
        return aiApi(original);
      } catch (refreshErr) {
        resolveQueue(refreshErr, null);
        if (refreshErr.response?.status === 401 || refreshErr.response?.status === 422) {
          store.dispatch(logout());
        }
        return Promise.reject(refreshErr);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

export default aiApi;

